/* src/components/admin/announcements/dashboard/AnnouncementCard.js */
import React, { useEffect, useState } from "react";
import { subscribeReadsCount } from "../AdminAnnouncementsLogic";
import { FiEdit2, FiTrash2, FiArchive, FiUsers } from "react-icons/fi";
import { BsPinAngle, BsPinFill } from "react-icons/bs";
import "./AnnouncementCard.css";

function fmtDate(ms) {
  if (!ms) return "";
  const d = new Date(ms);
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }) +
    " at " +
    d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
}

function safeCategory(cat) {
  return (cat || "").trim() || "General";
}

export default function AnnouncementCard({
  announcement,
  onOpenPost,
  onEdit,
  onDelete,
  onPin,
  onArchive,
  onOpenReads,
  onToast,
}) {
  const [readsCount, setReadsCount] = useState(0);

  useEffect(() => {
    const unsub = subscribeReadsCount(announcement.id, (n) => setReadsCount(n || 0));
    return () => unsub?.();
  }, [announcement.id]);

  const createdAtMs =
    announcement.createdAtMs ||
    (announcement.createdAt && typeof announcement.createdAt.toMillis === "function"
      ? announcement.createdAt.toMillis()
      : null);

  const audienceLabel =
    announcement.audienceType === "all"
      ? "All Tutors"
      : `${(announcement.audienceUserIds || []).length} Tutors`;

  return (
    <div className="aaCard" onClick={onOpenPost}>
      {/* Title row */}
      <div className="aaCardTitleRow">
        <div className="aaCardTitleLeft">
          {announcement.pinned && (
            <BsPinFill size={13} className="aaCardPinIcon" />
          )}
          <span className="aaCardTitle">{announcement.title || "(Untitled)"}</span>
        </div>
        <div className="aaCardTitleRight">
          <div className="aaCardActions" onClick={(e) => e.stopPropagation()}>
            <button
              className="aaCardActionBtn"
              title="Edit"
              onClick={(e) => { e.stopPropagation(); onEdit?.(); }}
            >
              <FiEdit2 size={14} />
            </button>
            <button
              className="aaCardActionBtn"
              title={announcement.pinned ? "Unpin" : "Pin"}
              onClick={(e) => { e.stopPropagation(); onPin?.(); }}
            >
              {announcement.pinned ? <BsPinFill size={14} /> : <BsPinAngle size={14} />}
            </button>
            <button
              className="aaCardActionBtn"
              title={announcement.archived ? "Restore" : "Archive"}
              onClick={(e) => { e.stopPropagation(); onArchive?.(); }}
            >
              <FiArchive size={14} />
            </button>
            <button
              className="aaCardActionBtn danger"
              title="Delete"
              onClick={(e) => { e.stopPropagation(); onDelete?.(); }}
            >
              <FiTrash2 size={14} />
            </button>
          </div>
        </div>
      </div>

      {/* Meta row */}
      <div className="aaCardMeta">
        <span className="aaCardCatTag">{safeCategory(announcement.category)}</span>
        <span className="aaCardMetaDot">·</span>
        <span>{announcement.createdByName || "Admin"}</span>
        <span className="aaCardMetaDot">·</span>
        <span>{fmtDate(createdAtMs)}</span>
        <span className="aaCardMetaDot">·</span>
        <span className="aaCardMetaAudience">
          <FiUsers size={12} /> {audienceLabel}
        </span>
        <span className="aaCardMetaDot">·</span>
        <button
          className="aaCardReadsBtn"
          title="Read receipts"
          onClick={(e) => { e.stopPropagation(); onOpenReads?.(); }}
        >
          Read: {readsCount}
        </button>
      </div>

      {/* Preview */}
      <div
        className="aaCardPreview"
        dangerouslySetInnerHTML={{ __html: announcement.contentHtml || "" }}
      />
    </div>
  );
}
